import QRCode from "react-qr-code";
import { toast } from "react-toastify";

export default function Referal({ user }) {
    let url = window.location.host;
    return (
        <div className="referral-container container slide-in-right">
            {user.account ? <QRCode value={"https://" + url + "/?ref=" + user.account} /> : ""}

            {user.account &&
                <>
                    <input type="text" value={user.account ? "https://" + url + "/?ref=" + user.account : ""} />
                    <button className="button-design" onClick={() => {
                        //copy to clipboard
                        let textField = document.createElement('textarea');
                        textField.innerText = "https://" + url + "/?ref=" + user.account;
                        document.body.appendChild(textField);
                        textField.select();
                        document.execCommand('copy');
                        textField.remove();
                        toast.success("Copied to clipboard")

                    }} >Copy</button>
                </>

            }

            <p>Earn 12% of the BNB used to buy from anyone who uses your referral link</p>
        </div>
    )
}